// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1UJHw","emails":"CreateEditClinics_emails__UT9Zf","emailTagLabel":"CreateEditClinics_emailTagLabel__3-5mh"};